import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiQucikstartCommandPluginKey = new PluginKey('aiQucikstartCommand');
